
import { apiurl } from '@/services/config'
export const applicationService = {
  Applist,
  AddApp,
  EditApp,
  sendpush,
  setMaintenance,
  setMaxOTP
}
// /apps/maintenance/

async function setMaintenance (mode) {
  return fetch(apiurl + '/backoffice/apps/maintenance/'+mode, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
      .then(data => {
        return data
      })
}

async function setMaxOTP (maxotp) {
  return fetch(apiurl + '/backoffice/apps/maxotp/'+maxotp, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
      .then(data => {
        return data
      })
}

async function Applist () {
  return fetch(apiurl + '/backoffice/apps', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function sendpush (postdata) {
  return fetch(apiurl + '/backoffice/apps/push', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function EditApp (postdata) {
  return fetch(apiurl + '/backoffice/apps', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}



async function AddApp (postdata) {
  var data = JSON.stringify({ postdata })

  const formData = new FormData()
  formData.append('image', postdata.logo)
  formData.append('item', JSON.stringify(JSON.parse(data).postdata))

  return fetch(apiurl + '/backoffice/apps', {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)

    if (!data.success) {
      if (response.status === 401) {
        console.log("CALL LOGOUT");
        localStorage.setItem('token',null);
        localStorage.clear();
        location.reload(true)
      }

      const error = (data && data.msg) || response.statusText

      return Promise.reject(error)
    }
    return data
  })
}
